import Swiper from 'swiper';
import {A11y, Autoplay, EffectCreative, Mousewheel, Navigation, Pagination, Thumbs} from 'swiper/modules';
import anime from "animejs";
import {isTouchDevice} from "../../../../default/global/js/touchDevice";

function resizeActiveSlide(swiperImageGallery, effInterval = 400, first = false) {
    let currentSlideIndex = swiperImageGallery.activeIndex;
    let i = 0;

    for (let slide of swiperImageGallery.slides) {
        let slideImgContainer = slide.querySelector('.imageGallery__img');
        let slideTextContainer = slide.querySelector('.imageGallery__text');
        if (slideImgContainer) {
            slideImgContainer.style.width = null;
        }
        if (slideTextContainer) {
            anime({
                targets: slideTextContainer,
                opacity: 0,
                easing: "linear",
                duration: effInterval
            });
        }
        slide.classList.remove('swiper-slide-scale');
    }
    if (first) {
        effInterval = 0;
    }
    setTimeout(function () {
        for (let slide of swiperImageGallery.slides) {
            let slideImgContainer = slide.querySelector('.imageGallery__img');
            let slideTextContainer = slide.querySelector('.imageGallery__text');
            if (i === currentSlideIndex && slide.classList.contains('swiper-slide-active')) {
                slide.classList.add('swiper-slide-scale');
                if (slideImgContainer) {
                    let slideImg = slideImgContainer.querySelector('img');
                    if (slideImg) {
                        if (slideImg.complete) {
                            slideImgContainer.style.width = slideImg.width + "px";
                        }
                        slideImg.onload = function () {
                            if (slideImg.complete) {
                                slideImgContainer.style.width = slideImg.width + "px";
                            }
                        };
                    }
                }
                if (slideTextContainer) {
                    anime({
                        targets: slideTextContainer,
                        opacity: 1,
                        easing: "linear",
                        duration: effInterval
                    });
                }
            }
            i++;
        }
    }, effInterval);
}

export function initImageGallery(query = document.querySelectorAll('.imageGallery')) {
    let loops = {
        xs: false,
        sm: false,
        md: false,
        lg: false
    };

    let defaultOptions = {
        autoplay_interval: 3000,
        eff_interval: 1000,
        direction: "horizontal",
        loop: true,
        slidesPerBreakpoint: {
            xs: 1.5,
            sm: 3,
            md: 4,
            lg: 4
        }
    };

    for (const el of query) {
        let options = {};
        loops = {
            xs: false,
            sm: false,
            md: false,
            lg: false
        };
        if (el.getAttribute('data-options') !== "") {
            options = JSON.parse(el.getAttribute('data-options'));
        }// If the element doesn't have 'data-options', check its parent
        if (!options) {
            const parentOptions = el.parentElement.getAttribute('data-options');
            if (parentOptions) {
                options = JSON.parse(parentOptions);
            }
        }


        options = {...defaultOptions, ...options};
        let countSlides = el.querySelectorAll('.swiper-slide').length;

        if (countSlides >= options.slidesPerBreakpoint.lg && options.loop) {
            loops.lg = true;
        }

        if (countSlides >= options.slidesPerBreakpoint.md && options.loop) {
            loops.md = true;
        }

        if (countSlides >= options.slidesPerBreakpoint.sm && options.loop) {
            loops.sm = true;
        }

        if (countSlides >= options.slidesPerBreakpoint.xs && options.loop) {
            loops.xs = true;
        }
        Swiper.use([Autoplay, Navigation]);
        let swiperOptions = {
            speed: options.eff_interval,
            autoHeight: true,
            slideToClickedSlide: false,
            preventClicks: false,
            spaceBetween: 20,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            autoplay: {
                delay: options.autoplay_interval,
            },
            breakpoints: {
                0: {
                    loop: loops.xs,
                    slidesPerView: options.slidesPerBreakpoint.xs,
                    spaceBetween: 10,
                },
                768: {
                    loop: loops.sm,
                    slidesPerView: options.slidesPerBreakpoint.sm,
                },
                1250: {
                    loop: loops.md,
                    slidesPerView: options.slidesPerBreakpoint.md,
                },
                1540: {
                    loop: loops.lg,
                    slidesPerView: options.slidesPerBreakpoint.lg
                }
            },
            on: {
                init: function () {
                    resizeActiveSlide(this, options.eff_interval, true);
                },
                slideChange: function () {
                    resizeActiveSlide(this, options.eff_interval);
                }
            },
        };
        if (options.variant === 'vertical') {
            handleVerticalSwiper(el, swiperOptions);
            continue;
        }
        const swiperImageGallery = new Swiper(el, swiperOptions);
        if (options.autoplay_interval === 0) {
            swiperImageGallery.autoplay.stop();
        }
        el.addEventListener('mouseover', function () {
            swiperImageGallery.autoplay.stop();
        });

        el.addEventListener('mouseleave', function () {
            swiperImageGallery.autoplay.start();
        });
    }
}

function handleVerticalSwiper(el,swiperOptions) {
    let swiperInstance;
    const mediaQueryListener = window.matchMedia("(max-width: 768px)");
    let baseOptions = {
        ...swiperOptions,
        rewind: true,
        autoplay: false,
        spaceBetween: 0,
        a11y: true,
        pagination: {
            el: el.querySelector(".swiper-pagination"),
            clickable: true,
        },
        slidesPerView: 1,
        on: null,
        loop: false,
        direction: "vertical",
        touch: true,
    };

    function initViewportSwiper(isMobile) {
        if (swiperInstance) swiperInstance.destroy(true, true);
        let swiperOptions;
        if (isMobile.matches) {
            swiperOptions = {
                ...baseOptions, ...{
                    creativeEffect: creativeEffectMobile,
                    direction: "horizontal",
                }
            };
        } else {
            swiperOptions = {
                ...baseOptions, ...{
                    creativeEffect: creativeEffectDesktop,
                    direction: "vertical",
                    mousewheel: true,

                }
            };
        }
        Swiper.use([ Mousewheel, Pagination, EffectCreative, A11y]);
        swiperInstance = new Swiper(el, swiperOptions);
        el.addEventListener('mouseover', function () {
            swiperInstance.autoplay.stop();
        });

        el.addEventListener('mouseleave', function () {
            swiperInstance.autoplay.start();
        });
    }
    initViewportSwiper(mediaQueryListener);
    mediaQueryListener.addEventListener("change", function () {
        initViewportSwiper(mediaQueryListener);
    });
}
const creativeEffectMobile = {
    prev: {
        translate: [0, 0, -1],
    },
    next: {
        translate: ["100%", 0, 0],
    }
};
const creativeEffectDesktop = {
    prev: {
        translate: [0, 0, -1],
    },
    next: {
        translate: [0, "100%", 0],
    },
};
